import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/_current/environment';
import {
  UsersAaptivV2,
  UsersV2,
} from '@skyfit/core-data-library/models/users-aaptiv-v2';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminUsersService {
  private readonly http = inject(HttpClient);

  getUsers(
    tenantId: string,
    deleted = false,
    nonMembers = false
  ): Observable<UsersAaptivV2> {
    const url = `${environment.aaptivServiceUrl}/api/v2/enterpriseUserGroup/${tenantId}/users?deleted=${deleted}&nonMembers=${nonMembers}`;
    return this.http.get<UsersAaptivV2>(url);
  }

  getUserFromTenant() {
    const url = `${environment.aaptivServiceUrl}/api/v1/admin/users`;
    return this.http.get<UsersV2>(url);
  }

  getAdminUsers(tenantId: string) {
    const url = `${environment.aaptivServiceUrl}/api/v2/enterpriseUserGroup/${tenantId}/users?admin=true`;
    return this.http.get<UsersAaptivV2>(url);
  }

  downloadEmailsCSV(emailsForExport): void {
    if (emailsForExport.length === 0) {
      console.warn('No failed or unprocessed emails to download');
      return;
    }

    const csvRows: string[] = ['Name,Email,Status'];

    const escapeCSVField = (field: string): string => {
      if (field.includes(',') || field.includes('"') || field.includes('\n')) {
        return `"${field.replace(/"/g, '""')}"`;
      }
      return field;
    };

    emailsForExport.forEach((item) => {
      const name = item.name ?? 'N/A';
      csvRows.push(
        `${escapeCSVField(name)},${escapeCSVField(
          item.email
        )},${item.status.toLowerCase()}`
      );
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const localDate = `${year}-${month}-${day}`;
    const filename = `users-list-${localDate}.csv`;
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
